import { ProductoDsTienda } from "../../business/entities/ProductoDsTienda";

export class ProductoDsTiendaModel implements ProductoDsTienda {

  constructor(
    public codigoBarra: string,
    public denominacion: string,
    public precio: number,
    public um: string,
    public periodo: string,
    public nroUsuarioMax: number,
    public estado: boolean,
    public esServicio: boolean,
    public esPlan: boolean,
    public familia?: string | undefined,
    public descripcion?: string | undefined,
  ) { }
  
  serialize(): ProductoDsTienda {
    return {
      codigoBarra: this.codigoBarra,
      denominacion: this.denominacion,
      descripcion: this.descripcion,
      precio: this.precio,
      um: this.um,
      familia: this.familia,
      estado: this.estado,
      esServicio: this.esServicio,
      esPlan: this.esPlan,
      periodo: this.periodo,
      nroUsuarioMax: this.nroUsuarioMax
    };
  }
  static deserialize(formatoBase: ProductoDsTienda): ProductoDsTiendaModel {
    return new ProductoDsTiendaModel(
      formatoBase.codigoBarra,
      formatoBase.denominacion,
      Number(formatoBase.precio),
      formatoBase.um,
      formatoBase.periodo,
      formatoBase.nroUsuarioMax,
      formatoBase.estado,
      formatoBase.esServicio,
      formatoBase.esServicio && Boolean(formatoBase.periodo),
      formatoBase.familia,
      formatoBase.descripcion
    );
  }
}
